import {
  SITES_RESET,
  SITE_SENDING,
  SITE_DOWNLOADED,
  SITES_DOWNLOADED,
  SITES_FAILED,
  SITES_PENDING,
} from './types';
import SitesApiService from '../../services/api/SitesApiService';
import { handleError } from '../infos/actions';

export const sitesResetAction = () => ({
  type: SITES_RESET,
});

export const siteSendingAction = () => ({
  type: SITE_SENDING,
});

export const siteDownloadedAction = (site) => ({
  type: SITE_DOWNLOADED,
  payload: site,
});

export const sitesDownloadedAction = (sites) => ({
  type: SITES_DOWNLOADED,
  payload: sites,
});

export const sitesFailedAction = (error) => ({
  type: SITES_FAILED,
  payload: error,
});

export const sitesPendingAction = () => ({
  type: SITES_PENDING,
});

export function resetSites() {
  return (dispatch) => {
    dispatch(sitesResetAction());
  };
}

export function getSites(authUserToken, role) {
  return (dispatch) => {
    dispatch(sitesPendingAction());
    return SitesApiService
      .getSites(authUserToken, role)
      .then((data) => {
        dispatch(sitesDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(sitesFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postSite(authUserToken, renterId, site) {
  return (dispatch) => {
    dispatch(siteSendingAction());
    return SitesApiService
      .postAdminSites(authUserToken, { renter_id: renterId, ...site })
      .then((data) => {
        dispatch(siteDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(sitesFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function putSite(authUserToken, role, siteId, site) {
  return (dispatch) => {
    dispatch(siteSendingAction());
    return SitesApiService
      .putSites(authUserToken, role, siteId, site)
      .then((data) => {
        dispatch(siteDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(sitesFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/sites/actions.js